import React from 'react';
import Section from 'components/common/Section';
import { Helmet } from 'react-helmet-async';

// Release Notes / Changelog.
// Neueste Version oben ergänzen: { version, description?, changes?: [] }
const releases = [
  {
    version: '2.0.3',
    changes: [
      'Verbesserte CTI-/IOC-Verarbeitung nach Änderungen im Elastic-Stack.',
      'Mehr Robustheit bei leeren Antworten und Sonderfällen in Auswertungen.',
      'Korrekte Zeitbereichsverarbeitung in Report-Queries.',
      'Überarbeitungen in Agenten- und Enrollment-Logik (inkl. Downloadquellen und Controller/Service-Refactoring).',
      'Aktualisierung sicherheits- und kompatibilitätsrelevanter Abhängigkeiten.',
      'Korrekturen bei Nutzernamen-/Realnamen-Behandlung.',
    ],
  },
  {
    version: '2.0.2',
    changes: [
      'Erweiterte Zeiträume in der Zeitauswahl (inkl. letzter 14 Tage).',
      'Verbesserte Stabilität bei Gesundheits- und Statusanzeigen (inkl. degradiertem Zustand).',
      'Korrekturen bei Übergaben von Zeitbereichen zwischen Ansichten.',
      'Verbesserte Konfigurierbarkeit und Zuverlässigkeit bei Elastic-bezogenen Timeouts und Verbindungen.',
      'Ergänzte fehlende Texte/Übersetzungen in Report- und Alert-Bereichen.',
    ],
  },
  {
    version: '2.0.1',
    changes: [
      'Umfassende Korrekturen bei Zeit- und Zeitzonenlogik.',
      'Deutlich verbesserte Qualität der Report-Daten (Zählungen, Werte, Darstellung).',
      'Einführung und Ausbau von Caching-Mechanismen für Report-bezogene Daten.',
      'Einheitlichere Zeitfilter über zentrale Ansichten hinweg.',
      'Mehr Robustheit bei fehlerhaften oder inkonsistenten Datenzuständen.',
    ],
  },
  {
    version: '2.0.0',
    description:
      'Die ScanBox wurde mit der Version 2.0 komplett runderneuert und basiert komplett auf Elastic SIEM. Damit nutzen wir ein starkes, verbreitetes System als Basis, was aktiv gepflegt wird.',
  },
];

const ReleaseNotes = () => {
  return (
    <>
      <Helmet>
        <title>Release Notes</title>
        <link
          rel="canonical"
          href="https://www.scanbox-product.de/ReleaseNotes"
        />
        <meta
          name="description"
          content="Release Notes und Änderungsprotokoll von ScanBox – neue Funktionen, Verbesserungen und behobene Fehler je Version."
        />
      </Helmet>
      <Section className="bg-body-tertiary px-2 pt-5">
        <div className=" px-3">
          <h2 className="text-header fw-bold pb-4 mb-2">Release Notes</h2>
          <p className="text-600 text-justify pb-4">
            Hier finden Sie einen Überblick über die Änderungen der einzelnen
            ScanBox-Versionen.
          </p>
          {releases.map((release) => (
            <div key={release.version} className="pb-4">
              <h3 className="text-header pb-1 pt-1">
                Version {release.version}
              </h3>
              {release.description && (
                <p className="text-600 text-justify pb-2">
                  {release.description}
                </p>
              )}
              {release.changes && release.changes.length > 0 && (
                <ul className="text-600 text-justify">
                  {release.changes.map((change, i) => (
                    <li key={i} className="pb-1">
                      {change}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </Section>
    </>
  );
};

export default ReleaseNotes;
